module.exports = __webpack_public_path__ + "static/img/ml.e6f097f9.svg";